import {
  FeedbackDescriptionDto,
  MemberSummaryFeedbackCreateRequest,
  MemberSummaryFeedbackDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const memberSummaryRequests = {
  getFeedbackDescriptions: EndpointDefinition.get<
    FeedbackDescriptionDto[],
    null
  >({
    name: 'getFeedbackDescriptions',
    route: '/users/member-summary/feedback-descriptions',
  }),
  createNewMemberSummaryFeedback: EndpointDefinition.post<
    MemberSummaryFeedbackDto,
    MemberSummaryFeedbackCreateRequest,
    null
  >({
    name: 'createNewMemberSummaryFeedback',
    route: '/users/member-summary/',
  }),
};
